{
  "level": "jctq1q3",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:jctq1q3",
    "objects": "AREAS.E3:jctq1q3.e3",
    "mesh": "TREES.E3:jctq1q3.e3"
  },
  "spawn_point": {
    "position": [
      1100.7757649739583,
      1606.2078287760417,
      101.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      1100.7757649739583,
      1706.2078287760417,
      101.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -724.7740478515625,
      -1709.192626953125,
      77.0
    ],
    "bbox_max": [
      3020.6171875,
      7185.4150390625,
      710.5693969726562
    ],
    "vertex_count": 210,
    "vertices": [
      [
        2769.303955078125,
        7185.4150390625,
        710.5693969726562
      ],
      [
        3020.6171875,
        6729.98193359375,
        570.58251953125
      ],
      [
        -724.7740478515625,
        -1709.192626953125,
        200.32070922851562
      ],
      [
        1549.9998779296875,
        1550.0,
        370.0
      ],
      [
        1549.9998779296875,
        1550.0,
        500.0
      ],
      [
        1549.9998779296875,
        1550.0,
        370.0
      ],
      [
        1549.9998779296875,
        1550.0,
        140.0
      ],
      [
        1480.0,
        1550.0,
        140.0
      ],
      [
        1480.0,
        1550.0,
        138.0
      ],
      [
        1530.0,
        1550.0,
        138.0
      ],
      [
        1530.0,
        1550.0,
        140.0
      ],
      [
        1530.0,
        1550.0,
        120.0
      ],
      [
        1549.9998779296875,
        1550.0,
        140.0
      ],
      [
        1250.0,
        1550.0,
        140.0
      ],
      [
        1250.0,
        1550.0,
        100.0
      ],
      [
        1250.0,
        1550.0,
        140.0
      ],
      [
        1290.0,
        1550.0,
        190.0
      ],
      [
        1030.0,
        1120.0,
        130.0
      ],
      [
        1030.0,
        1120.0,
        130.0
      ],
      [
        1030.0,
        1120.0,
        82.10526275634766
      ],
      [
        1030.0,
        1120.0,
        118.0
      ],
      [
        1110.0,
        1120.9599609375,
        118.0
      ],
      [
        1030.0,
        1120.9599609375,
        118.0
      ],
      [
        1030.0,
        1300.0,
        160.0
      ],
      [
        1030.0,
        1300.0,
        180.0
      ],
      [
        1030.0,
        1280.0,
        160.0
      ],
      [
        1030.0,
        1300.0,
        160.0
      ],
      [
        1030.0,
        1140.0,
        118.0
      ],
      [
        1030.0,
        1140.0,
        120.0
      ],
      [
        1030.0,
        1140.0,
        118.0
      ],
      [
        1235.0,
        1550.0,
        118.0
      ],
      [
        1215.0,
        1550.0,
        118.0
      ],
      [
        1215.0,
        1550.0,
        118.0
      ],
      [
        1215.0,
        1550.0,
        120.0
      ],
      [
        1010.0,
        1120.0,
        118.0
      ],
      [
        1030.0,
        1120.9599609375,
        118.0
      ],
      [
        1010.0,
        1120.9599609375,
        118.0
      ],
      [
        999.0400390625,
        1120.9599609375,
        118.0
      ],
      [
        945.5584716796875,
        1550.0,
        100.0
      ],
      [
        980.0,
        1550.0,
        100.0
      ],
      [
        1000.0,
        1550.0,
        100.0
      ],
      [
        820.0,
        1540.0,
        100.0
      ],
      [
        945.5584716796875,
        1540.0,
        100.0
      ],
      [
        820.0,
        1550.0,
        80.0
      ],
      [
        945.5584716796875,
        1550.0,
        100.0
      ],
      [
        820.0,
        1550.0,
        120.0
      ],
      [
        945.5584716796875,
        1550.0,
        120.0
      ],
      [
        945.5584716796875,
        1550.0,
        140.0
      ],
      [
        1534.761962890625,
        1690.0,
        124.76190185546875
      ],
      [
        1534.7618408203125,
        1550.0,
        124.76190185546875
      ],
      [
        1030.0,
        1620.0,
        80.86956024169922
      ],
      [
        1030.0,
        1690.0,
        80.86956787109375
      ],
      [
        1030.0,
        1550.0,
        80.86956024169922
      ],
      [
        1030.0,
        1570.0,
        80.86956787109375
      ],
      [
        1058.333251953125,
        1620.0,
        83.33332824707031
      ],
      [
        1058.333251953125,
        1570.0,
        83.33332824707031
      ],
      [
        1030.0,
        1570.0,
        80.86956024169922
      ],
      [
        1058.333251953125,
        1570.0,
        83.33332824707031
      ],
      [
        1266.0,
        1570.0,
        160.0
      ],
      [
        1266.0,
        1550.0,
        160.0
      ],
      [
        1549.9998779296875,
        1570.0,
        140.0
      ],
      [
        1534.7618408203125,
        1570.0,
        124.76190185546875
      ],
      [
        1257.78759765625,
        1570.0,
        149.7344512939453
      ],
      [
        1257.78759765625,
        1550.0,
        149.7344512939453
      ],
      [
        1530.0,
        1570.0,
        138.0
      ],
      [
        1530.0,
        1570.0,
        140.0
      ],
      [
        1480.0,
        1570.0,
        140.0
      ],
      [
        1480.0,
        1570.0,
        138.0
      ],
      [
        1030.0,
        1550.0,
        113.45055389404297
      ],
      [
        1030.0,
        1570.0,
        113.45055389404297
      ],
      [
        1235.0,
        1570.0,
        118.0
      ],
      [
        1215.0,
        1570.0,
        118.0
      ],
      [
        1215.0,
        1570.0,
        118.0
      ],
      [
        1215.0,
        1570.0,
        120.0
      ],
      [
        980.0,
        1570.0,
        100.0
      ],
      [
        1000.0,
        1570.0,
        100.0
      ],
      [
        1030.0,
        1550.0,
        120.0
      ],
      [
        1030.0,
        1570.0,
        120.0
      ],
      [
        1055.68994140625,
        1690.0,
        177.0
      ],
      [
        1055.68994140625,
        1630.0,
        177.0
      ],
      [
        1346.8421630859375,
        1610.0,
        177.0
      ],
      [
        1346.8421630859375,
        1600.0,
        177.0
      ],
      [
        955.0,
        1655.0,
        177.0
      ],
      [
        980.0,
        1670.0,
        177.0
      ],
      [
        945.0,
        1665.0,
        177.0
      ],
      [
        955.0,
        1655.0,
        177.0
      ],
      [
        980.0,
        1590.0,
        177.0
      ],
      [
        955.0,
        1605.0,
        177.0
      ],
      [
        955.0,
        1605.0,
        177.0
      ],
      [
        945.0,
        1595.0,
        177.0
      ],
      [
        955.0,
        1655.0,
        158.0
      ],
      [
        980.0,
        1670.0,
        158.0
      ],
      [
        945.0,
        1665.0,
        158.0
      ],
      [
        955.0,
        1655.0,
        158.0
      ],
      [
        980.0,
        1590.0,
        158.0
      ],
      [
        955.0,
        1605.0,
        158.0
      ],
      [
        955.0,
        1605.0,
        158.0
      ],
      [
        945.0,
        1595.0,
        158.0
      ],
      [
        1037.5947265625,
        1630.0,
        150.0
      ],
      [
        1037.5947265625,
        1690.0,
        150.0
      ],
      [
        955.0,
        1655.0,
        150.0
      ],
      [
        980.0,
        1670.0,
        150.0
      ],
      [
        945.0,
        1665.0,
        150.0
      ],
      [
        955.0,
        1655.0,
        150.0
      ],
      [
        980.0,
        1590.0,
        150.0
      ],
      [
        955.0,
        1605.0,
        150.0
      ],
      [
        955.0,
        1605.0,
        150.0
      ],
      [
        945.0,
        1595.0,
        150.0
      ],
      [
        1280.0,
        1602.0001220703125,
        138.0
      ],
      [
        1270.0,
        1602.0001220703125,
        138.0
      ],
      [
        1492.0001220703125,
        1602.0001220703125,
        138.0
      ],
      [
        1425.0,
        1602.0001220703125,
        138.0
      ],
      [
        1280.0,
        1602.0001220703125,
        138.0
      ],
      [
        1425.0,
        1602.0001220703125,
        138.0
      ],
      [
        810.0,
        1610.0,
        140.0
      ],
      [
        950.0,
        1610.0,
        140.0
      ],
      [
        955.0,
        1605.0,
        140.0
      ],
      [
        963.333251953125,
        1600.0001220703125,
        140.0
      ],
      [
        950.0,
        1608.0,
        140.0
      ],
      [
        960.0,
        1602.0,
        150.0
      ],
      [
        955.0,
        1605.0,
        145.0000457763672
      ],
      [
        945.0,
        1595.0,
        145.00003051757812
      ],
      [
        950.0000610351562,
        1600.0001220703125,
        140.0
      ],
      [
        955.0,
        1605.0,
        140.0
      ],
      [
        950.0,
        1610.0,
        140.0
      ],
      [
        960.0,
        1610.0,
        150.0
      ],
      [
        1549.9998779296875,
        1610.0,
        140.0
      ],
      [
        1549.9998779296875,
        1600.0,
        140.0
      ],
      [
        1547.9998779296875,
        1602.0,
        138.0
      ],
      [
        1547.9998779296875,
        1610.0,
        138.0
      ],
      [
        1270.0,
        1602.0001220703125,
        138.0
      ],
      [
        1270.0,
        1600.0,
        140.0
      ],
      [
        1530.0,
        1602.0001220703125,
        138.0
      ],
      [
        1530.0,
        1610.0,
        138.0
      ],
      [
        1530.0,
        1610.0,
        140.0
      ],
      [
        1530.0,
        1600.0,
        140.0
      ],
      [
        955.0,
        1605.0,
        138.0
      ],
      [
        959.9998779296875,
        1602.0001220703125,
        138.0
      ],
      [
        955.0,
        1605.0,
        138.0
      ],
      [
        952.0000610351562,
        1602.0001220703125,
        138.0
      ],
      [
        1540.0,
        1610.0,
        130.00009155273438
      ],
      [
        955.0,
        1605.0,
        135.00009155273438
      ],
      [
        955.0,
        1605.0,
        135.00009155273438
      ],
      [
        1547.9998779296875,
        1570.0,
        138.0
      ],
      [
        1547.9998779296875,
        1602.0,
        138.0
      ],
      [
        980.0,
        1590.0,
        138.0
      ],
      [
        959.9998779296875,
        1602.0001220703125,
        138.0
      ],
      [
        952.0000610351562,
        1602.0001220703125,
        138.0
      ],
      [
        945.0,
        1595.0,
        138.0
      ],
      [
        1534.7618408203125,
        1610.0,
        124.76190185546875
      ],
      [
        980.0,
        1590.0,
        118.0
      ],
      [
        955.0,
        1605.0,
        118.0
      ],
      [
        955.0,
        1605.0,
        118.0
      ],
      [
        945.0,
        1595.0,
        118.0
      ],
      [
        1238.8043212890625,
        1598.0,
        118.0
      ],
      [
        1037.5947265625,
        1630.0,
        140.0
      ],
      [
        1037.5947265625,
        1690.0,
        140.0
      ],
      [
        945.0,
        1665.0,
        140.0
      ],
      [
        955.0,
        1655.0,
        145.0000457763672
      ],
      [
        949.9999389648438,
        1660.0,
        140.0
      ],
      [
        955.0,
        1655.0,
        145.0000457763672
      ],
      [
        960.0,
        1658.0,
        150.0
      ],
      [
        955.0,
        1655.0,
        140.0
      ],
      [
        980.0,
        1670.0,
        140.0
      ],
      [
        955.0,
        1655.0,
        140.0
      ],
      [
        1036.5,
        1690.0,
        118.0
      ],
      [
        1036.5,
        1628.55859375,
        118.0
      ],
      [
        1037.156005859375,
        1620.0,
        119.81653594970703
      ],
      [
        1037.156005859375,
        1610.0,
        119.81653594970703
      ],
      [
        1037.156005859375,
        1620.0,
        119.81653594970703
      ],
      [
        1036.5,
        1620.0,
        118.0
      ],
      [
        940.0,
        1650.0,
        118.0
      ],
      [
        940.0,
        1610.0,
        118.0
      ],
      [
        955.0,
        1655.0,
        118.0
      ],
      [
        980.0,
        1670.0,
        118.0
      ],
      [
        945.0,
        1665.0,
        118.0
      ],
      [
        955.0,
        1655.0,
        118.0
      ],
      [
        1033.75,
        1620.0,
        118.0
      ],
      [
        1033.75,
        1610.0,
        118.0
      ],
      [
        1033.75,
        1620.0,
        118.0
      ],
      [
        885.0,
        1650.0,
        100.0
      ],
      [
        885.0,
        1640.0,
        98.0
      ],
      [
        885.0,
        1640.0,
        100.0
      ],
      [
        895.0,
        1650.0,
        100.0
      ],
      [
        885.0,
        1650.0,
        100.0
      ],
      [
        895.0,
        1640.0,
        98.0
      ],
      [
        895.0,
        1650.0,
        100.0
      ],
      [
        895.0,
        1640.0,
        100.0
      ],
      [
        1003.75,
        1620.0,
        100.0
      ],
      [
        895.0,
        1635.0,
        100.0
      ],
      [
        885.0,
        1635.0,
        100.0
      ],
      [
        895.0,
        1635.0,
        100.0
      ],
      [
        895.0,
        1625.0,
        100.0
      ],
      [
        895.0,
        1625.0,
        100.0
      ],
      [
        885.0,
        1625.0,
        100.0
      ],
      [
        885.0,
        1635.0,
        100.0
      ],
      [
        885.0,
        1625.0,
        100.0
      ],
      [
        970.0,
        1660.0,
        87.0
      ],
      [
        950.0,
        1660.0,
        87.0
      ],
      [
        950.0,
        1660.0,
        87.0
      ],
      [
        950.0,
        1660.0,
        77.0
      ],
      [
        970.0,
        1660.0,
        77.0
      ],
      [
        970.0,
        1660.0,
        87.0
      ],
      [
        945.0,
        1630.02734375,
        98.0
      ],
      [
        970.0,
        1630.0130615234375,
        87.0
      ],
      [
        950.0,
        1630.0130615234375,
        87.0
      ],
      [
        970.0,
        1630.0130615234375,
        87.0
      ],
      [
        950.0,
        1630.0130615234375,
        87.0
      ],
      [
        1036.261474609375,
        1620.0,
        117.33944702148438
      ],
      [
        1036.5,
        1620.0,
        118.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        -900.0,
        -3700.0,
        -33.027774810791016
      ],
      "bbox_max": [
        6306.5068359375,
        7196.82421875,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238756537437439,
        -0.5008544325828552,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        -900.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        6306.5068359375,
        7196.82421875,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5679554343223572,
        -0.4636738896369934,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        2769.303955078125,
        4951.876953125,
        0.0
      ],
      "bbox_max": [
        4964.0634765625,
        7185.4150390625,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        2769.303955078125,
        6729.98193359375,
        570.58251953125
      ],
      "bbox_max": [
        3020.6171875,
        7185.4150390625,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        -900.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        3045.157470703125,
        7196.82421875,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -900.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        2400.0,
        1690.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.052745044231414795,
        0.6877359747886658,
        0.7240423560142517
      ],
      "plane_d": 740.0003051757812,
      "bbox_min": [
        -900.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        2400.0,
        1690.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        -900.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        2400.0,
        -1371.68505859375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.054435841739177704,
        0.9979904890060425,
        0.032430119812488556
      ],
      "plane_d": 3654.259033203125,
      "bbox_min": [
        -900.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        1775.0,
        -1709.192626953125,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -900.0,
        -2500.0,
        200.32070922851562
      ],
      "bbox_max": [
        0.0,
        -1709.192626953125,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -724.7740478515625,
        -2500.0,
        0.0
      ],
      "bbox_max": [
        650.0,
        -1371.68505859375,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -724.7740478515625,
        -2500.0,
        0.0
      ],
      "bbox_max": [
        0.0,
        -1371.68505859375,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1689.9998779296875,
      "bbox_min": [
        760.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        515.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1550.0,
      "bbox_min": [
        760.0,
        930.0,
        64.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        760.0,
        930.0,
        64.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1550.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1030.0,
        1100.0,
        82.10526275634766
      ],
      "bbox_max": [
        1549.9998779296875,
        1550.0,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -5.307405217536143e-07
      ],
      "plane_d": 1550.0001220703125,
      "bbox_min": [
        1480.0,
        1428.0,
        120.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1550.0,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        1480.0,
        1428.0,
        120.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1550.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        1530.0,
        1490.0,
        120.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1550.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 997.0205688476562,
      "bbox_min": [
        1530.0,
        1500.0,
        120.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1550.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1030.0,
        1100.0,
        82.10526275634766
      ],
      "bbox_max": [
        1290.0,
        1550.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1250.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1290.0,
        1550.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974521815776825
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        1030.0,
        1100.0,
        82.10526275634766
      ],
      "bbox_max": [
        1235.0,
        1550.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1030.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1110.0,
        1120.9599609375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        1030.0,
        1120.9599609375,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1030.0,
        1120.9599609375,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1030.0,
        1120.9599609375,
        118.0
      ],
      "bbox_max": [
        1110.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1030.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1100.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        1460.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1550.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1460.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1550.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974521815776825
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        760.0,
        930.0,
        64.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1010.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1120.9599609375,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1010.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1120.9599609375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        999.0400390625,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1010.0,
        1120.9599609375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1279.9998779296875,
      "bbox_min": [
        760.0,
        1120.9599609375,
        64.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        280.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        980.0,
        1120.9599609375,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1255.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        980.0,
        1160.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1255.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        980.0,
        1160.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1160.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        980.0,
        1120.9599609375,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1000.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        820.0,
        1280.0,
        64.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        180.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.15730521082878113,
        0.0,
        0.9875500798225403
      ],
      "plane_d": 49.98626708984375,
      "bbox_min": [
        820.0,
        1540.0,
        80.0
      ],
      "bbox_max": [
        945.5584716796875,
        1550.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        820.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        980.0,
        1280.0,
        160.0
      ],
      "bbox_max": [
        1030.0,
        1300.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        980.0,
        1300.0,
        160.0
      ],
      "bbox_max": [
        1030.0,
        1300.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        820.0,
        1540.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        945.5584716796875,
        1540.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -5.307405217536143e-07
      ],
      "plane_d": 1550.0001220703125,
      "bbox_min": [
        780.0,
        1550.0,
        77.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.08662962168455124,
        0.0,
        0.9962406754493713
      ],
      "plane_d": 8.662956237792969,
      "bbox_min": [
        780.0,
        1550.0,
        77.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 997.0205688476562,
      "bbox_min": [
        1030.0,
        1550.0,
        80.0
      ],
      "bbox_max": [
        1534.761962890625,
        1690.0,
        124.76190185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1550.0,
        80.0
      ],
      "bbox_max": [
        1058.333251953125,
        1690.0,
        83.33332824707031
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        1030.0,
        1570.0,
        80.0
      ],
      "bbox_max": [
        1058.333251953125,
        1620.0,
        83.33332824707031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        1030.0,
        1570.0,
        80.0
      ],
      "bbox_max": [
        1058.333251953125,
        1570.0,
        83.33332824707031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        780.0,
        1550.0,
        77.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        216.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        820.0,
        1550.0,
        80.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1570.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1266.0,
        1550.0,
        160.0
      ],
      "bbox_max": [
        1290.0,
        1570.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 997.0205688476562,
      "bbox_min": [
        1250.0,
        1550.0,
        124.76190185546875
      ],
      "bbox_max": [
        1549.9998779296875,
        1570.0,
        149.7344512939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1250.0,
        1550.0,
        138.0
      ],
      "bbox_max": [
        1530.0,
        1570.0,
        149.7344512939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        1480.0,
        1550.0,
        138.0
      ],
      "bbox_max": [
        1480.0,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        945.5584716796875,
        1550.0,
        80.86956024169922
      ],
      "bbox_max": [
        1235.0,
        1570.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        1550.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1570.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1550.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1570.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        945.5584716796875,
        1550.0,
        100.0
      ],
      "bbox_max": [
        1000.0,
        1570.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        820.0,
        1550.0,
        113.45055389404297
      ],
      "bbox_max": [
        1266.0,
        1570.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        945.5584716796875,
        1550.0,
        120.0
      ],
      "bbox_max": [
        1266.0,
        1570.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1257.78759765625,
        1550.0,
        149.7344512939453
      ],
      "bbox_max": [
        1266.0,
        1570.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        945.5584716796875,
        1550.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1550.0,
        113.45055389404297
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        780.0,
        1570.0,
        77.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        216.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 149.99998474121094,
      "bbox_min": [
        790.0,
        1570.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 157.99998474121094,
      "bbox_min": [
        945.0,
        1570.0,
        150.0
      ],
      "bbox_max": [
        1488.300048828125,
        1690.0,
        216.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 176.99998474121094,
      "bbox_min": [
        945.0,
        1570.0,
        158.0
      ],
      "bbox_max": [
        1488.300048828125,
        1690.0,
        216.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7241379618644714,
        0.0,
        0.6896552443504333
      ],
      "plane_d": 642.396240234375,
      "bbox_min": [
        945.0,
        1590.0,
        177.0
      ],
      "bbox_max": [
        1350.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5350520610809326,
        0.0,
        0.8448190689086914
      ],
      "plane_d": 571.09765625,
      "bbox_min": [
        1346.8421630859375,
        1600.0,
        177.0
      ],
      "bbox_max": [
        1350.0,
        1610.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        945.0,
        1590.0,
        177.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1845.548828125,
      "bbox_min": [
        945.0,
        1655.0,
        177.0
      ],
      "bbox_max": [
        955.0,
        1665.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        945.0,
        1590.0,
        177.0
      ],
      "bbox_max": [
        980.0,
        1605.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        945.0,
        1595.0,
        177.0
      ],
      "bbox_max": [
        955.0,
        1605.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1590.0,
      "bbox_min": [
        945.0,
        1570.0,
        158.0
      ],
      "bbox_max": [
        1435.0,
        1690.0,
        177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1300.0,
        1570.0,
        158.0
      ],
      "bbox_max": [
        1300.0,
        1590.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7241379618644714,
        0.0,
        0.6896552443504333
      ],
      "plane_d": 642.396240234375,
      "bbox_min": [
        945.0,
        1590.0,
        158.0
      ],
      "bbox_max": [
        1346.8421630859375,
        1690.0,
        177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5350520610809326,
        0.0,
        0.8448190689086914
      ],
      "plane_d": 571.09765625,
      "bbox_min": [
        1300.0,
        1590.0,
        158.0
      ],
      "bbox_max": [
        1346.8421630859375,
        1610.0,
        177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1300.0,
        1590.0,
        158.0
      ],
      "bbox_max": [
        1300.0,
        1610.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        945.0,
        1590.0,
        158.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1845.548828125,
      "bbox_min": [
        945.0,
        1655.0,
        158.0
      ],
      "bbox_max": [
        955.0,
        1665.0,
        177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        945.0,
        1590.0,
        158.0
      ],
      "bbox_max": [
        980.0,
        1605.0,
        177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        945.0,
        1595.0,
        158.0
      ],
      "bbox_max": [
        955.0,
        1605.0,
        177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.030754676088690758,
        0.0,
        -0.9995269775390625
      ],
      "plane_d": 117.94418334960938,
      "bbox_min": [
        945.0,
        1590.0,
        150.0
      ],
      "bbox_max": [
        1300.0,
        1690.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.5947265625,
      "bbox_min": [
        945.0,
        1590.0,
        150.0
      ],
      "bbox_max": [
        1235.0,
        1690.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 156.0,
      "bbox_min": [
        1215.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1235.0,
        1630.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1215.0,
        1630.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        945.0,
        1590.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1845.548828125,
      "bbox_min": [
        945.0,
        1655.0,
        150.0
      ],
      "bbox_max": [
        955.0,
        1665.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        945.0,
        1590.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1605.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        945.0,
        1595.0,
        150.0
      ],
      "bbox_max": [
        955.0,
        1605.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1610.0,
      "bbox_min": [
        800.0,
        1570.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        150.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 1230.3658447265625,
      "bbox_min": [
        800.0,
        1570.0,
        118.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1610.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        810.0,
        1590.0,
        130.00009155273438
      ],
      "bbox_max": [
        1549.9998779296875,
        1610.0,
        150.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        810.0,
        1590.0,
        138.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1610.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        945.0,
        1590.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1610.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -572.7564697265625,
      "bbox_min": [
        945.0,
        1590.0,
        140.0
      ],
      "bbox_max": [
        960.0,
        1608.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        945.0,
        1595.0,
        140.0
      ],
      "bbox_max": [
        955.0,
        1605.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        950.0000610351562,
        1600.0001220703125,
        140.0
      ],
      "bbox_max": [
        955.0,
        1605.0,
        145.0000457763672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -572.7564697265625,
      "bbox_min": [
        950.0,
        1602.0,
        140.0
      ],
      "bbox_max": [
        960.0,
        1610.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 997.0205688476562,
      "bbox_min": [
        950.0000610351562,
        1600.0,
        138.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1610.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        950.0000610351562,
        1600.0,
        138.0
      ],
      "bbox_max": [
        1530.0,
        1610.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        1530.0,
        1600.0,
        138.0
      ],
      "bbox_max": [
        1530.0,
        1610.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        950.0000610351562,
        1600.0001220703125,
        138.0
      ],
      "bbox_max": [
        963.333251953125,
        1605.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        950.0000610351562,
        1600.0001220703125,
        138.0
      ],
      "bbox_max": [
        955.0,
        1605.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 997.0205688476562,
      "bbox_min": [
        952.0000610351562,
        1602.0,
        130.00009155273438
      ],
      "bbox_max": [
        1547.9998779296875,
        1610.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        952.0000610351562,
        1602.0001220703125,
        135.00009155273438
      ],
      "bbox_max": [
        959.9998779296875,
        1605.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        952.0000610351562,
        1602.0001220703125,
        135.00009155273438
      ],
      "bbox_max": [
        955.0,
        1605.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        945.0,
        1570.0,
        118.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1610.0,
        150.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 997.0205688476562,
      "bbox_min": [
        945.0,
        1570.0,
        138.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1602.0001220703125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        945.0,
        1570.0,
        138.0
      ],
      "bbox_max": [
        1530.0,
        1602.0001220703125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        945.0,
        1595.0,
        138.0
      ],
      "bbox_max": [
        952.0000610351562,
        1602.0001220703125,
        145.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1415.0,
      "bbox_min": [
        1270.0,
        1570.0,
        138.0
      ],
      "bbox_max": [
        1480.0,
        1602.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        1480.0,
        1570.0,
        138.0
      ],
      "bbox_max": [
        1480.0,
        1590.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1270.0,
        1590.0,
        138.0
      ],
      "bbox_max": [
        1270.0,
        1602.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 997.0205688476562,
      "bbox_min": [
        945.0,
        1570.0,
        118.0
      ],
      "bbox_max": [
        1547.9998779296875,
        1610.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        945.0,
        1570.0,
        118.0
      ],
      "bbox_max": [
        1238.8043212890625,
        1610.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        945.0,
        1595.0,
        118.0
      ],
      "bbox_max": [
        955.0,
        1605.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1020.0,
      "bbox_min": [
        1020.0,
        1570.0,
        118.0
      ],
      "bbox_max": [
        1238.8043212890625,
        1610.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1570.0,
        118.0
      ],
      "bbox_max": [
        1238.8043212890625,
        1598.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1598.0,
      "bbox_min": [
        1235.0,
        1598.0,
        118.0
      ],
      "bbox_max": [
        1238.8043212890625,
        1598.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        810.0,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.5947265625,
      "bbox_min": [
        945.0,
        1610.0,
        140.0
      ],
      "bbox_max": [
        1037.5947265625,
        1690.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -572.7564697265625,
      "bbox_min": [
        945.0,
        1610.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1845.548828125,
      "bbox_min": [
        945.0,
        1655.0,
        140.0
      ],
      "bbox_max": [
        960.0,
        1665.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        955.0,
        1655.0,
        145.0000457763672
      ],
      "bbox_max": [
        960.0,
        1658.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        949.9999389648438,
        1655.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1845.548828125,
      "bbox_min": [
        949.9999389648438,
        1655.0,
        140.0
      ],
      "bbox_max": [
        955.0,
        1660.0,
        145.0000457763672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 997.0205688476562,
      "bbox_min": [
        940.0,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1530.0,
        1650.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        1530.0,
        1610.0,
        138.0
      ],
      "bbox_max": [
        1530.0,
        1640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9405532479286194,
        0.0,
        0.3396463692188263
      ],
      "plane_d": 934.80517578125,
      "bbox_min": [
        940.0,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1037.5947265625,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47058823704719543,
        0.0,
        0.8823529481887817
      ],
      "plane_d": 382.3529357910156,
      "bbox_min": [
        1036.5,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1036.5,
        1620.0,
        118.0
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        940.0,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1037.156005859375,
        1670.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        945.0,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1037.156005859375,
        1670.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1845.548828125,
      "bbox_min": [
        945.0,
        1655.0,
        118.0
      ],
      "bbox_max": [
        955.0,
        1665.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.47058823704719543,
        0.0,
        0.8823529481887817
      ],
      "plane_d": 382.3529357910156,
      "bbox_min": [
        1033.75,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1037.156005859375,
        1620.0,
        119.81653594970703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1033.75,
        1620.0,
        118.0
      ],
      "bbox_max": [
        1037.156005859375,
        1620.0,
        119.81653594970703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        780.0,
        1570.0,
        77.0
      ],
      "bbox_max": [
        1269.77294921875,
        1690.0,
        118.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        860.0,
        1570.0,
        77.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1585.0,
      "bbox_min": [
        860.0,
        1585.0,
        77.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        860.0,
        1585.0,
        77.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -77.0,
      "bbox_min": [
        860.0,
        1585.0,
        77.0
      ],
      "bbox_max": [
        1030.0,
        1660.0999755859375,
        100.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        860.0,
        1585.0,
        77.0
      ],
      "bbox_max": [
        1030.0,
        1660.0999755859375,
        100.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1640.0,
      "bbox_min": [
        885.0,
        1620.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1650.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -885.0,
      "bbox_min": [
        885.0,
        1640.0,
        98.0
      ],
      "bbox_max": [
        895.0,
        1650.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 895.0,
      "bbox_min": [
        895.0,
        1640.0,
        98.0
      ],
      "bbox_max": [
        895.0,
        1650.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1961161345243454,
        0.0,
        0.9805806875228882
      ],
      "plane_d": 79.42704010009766,
      "bbox_min": [
        885.0,
        1620.0,
        98.0
      ],
      "bbox_max": [
        1003.75,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1625.669921875,
      "bbox_min": [
        912.5,
        1620.0,
        98.0
      ],
      "bbox_max": [
        1003.75,
        1634.330078125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1000.0,
        1620.0,
        98.0
      ],
      "bbox_max": [
        1003.75,
        1620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -16.10064697265625,
      "bbox_min": [
        912.5,
        1625.669921875,
        98.0
      ],
      "bbox_max": [
        922.5,
        1634.330078125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -1605.2529296875,
      "bbox_min": [
        912.5,
        1625.669921875,
        98.0
      ],
      "bbox_max": [
        915.0,
        1634.330078125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 24.76092529296875,
      "bbox_min": [
        912.5,
        1630.0,
        98.0
      ],
      "bbox_max": [
        915.0,
        1634.330078125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1635.0,
      "bbox_min": [
        885.0,
        1625.0,
        98.0
      ],
      "bbox_max": [
        905.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -885.0,
      "bbox_min": [
        885.0,
        1635.0,
        98.0
      ],
      "bbox_max": [
        895.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 895.0,
      "bbox_min": [
        895.0,
        1635.0,
        98.0
      ],
      "bbox_max": [
        895.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1625.0,
      "bbox_min": [
        885.0,
        1625.0,
        98.0
      ],
      "bbox_max": [
        905.0,
        1635.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -885.0,
      "bbox_min": [
        885.0,
        1625.0,
        98.0
      ],
      "bbox_max": [
        885.0,
        1635.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        860.0,
        1585.0,
        77.0
      ],
      "bbox_max": [
        980.0,
        1660.0999755859375,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1660.0999755859375,
      "bbox_min": [
        950.0,
        1660.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1660.0999755859375,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 87.0,
      "bbox_min": [
        950.0,
        1660.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1660.0999755859375,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        950.0,
        1660.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1660.0999755859375,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        970.0,
        1660.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1660.0999755859375,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -860.0,
      "bbox_min": [
        860.0,
        1585.0,
        77.0
      ],
      "bbox_max": [
        980.0,
        1660.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        860.0,
        1585.0,
        77.0
      ],
      "bbox_max": [
        980.0,
        1660.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999991655349731,
        0.0013020822079852223
      ],
      "plane_d": 1629.8984375,
      "bbox_min": [
        860.0,
        1595.0,
        77.0
      ],
      "bbox_max": [
        980.0,
        1660.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 945.0,
      "bbox_min": [
        885.0,
        1630.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1660.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        950.0,
        1630.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1660.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        885.0,
        1630.0,
        77.0
      ],
      "bbox_max": [
        916.0,
        1660.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.47058823704719543,
        0.8823529481887817
      ],
      "plane_d": -855.88232421875,
      "bbox_min": [
        885.0,
        1635.0,
        90.0
      ],
      "bbox_max": [
        895.0,
        1660.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -885.0,
      "bbox_min": [
        885.0,
        1635.0,
        90.0
      ],
      "bbox_max": [
        895.0,
        1660.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -90.0,
      "bbox_min": [
        885.0,
        1650.0,
        90.0
      ],
      "bbox_max": [
        895.0,
        1660.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5263546109199524,
        0.0,
        0.8502651453018188
      ],
      "plane_d": -547.6112060546875,
      "bbox_min": [
        895.0,
        1650.0,
        77.0
      ],
      "bbox_max": [
        916.0,
        1660.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1650.0,
      "bbox_min": [
        895.0,
        1650.0,
        77.0
      ],
      "bbox_max": [
        916.0,
        1650.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        870.0,
        1595.0,
        77.0
      ],
      "bbox_max": [
        980.0,
        1630.02734375,
        98.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 945.0,
      "bbox_min": [
        945.0,
        1630.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1630.02734375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        950.0,
        1630.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1630.0130615234375,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        970.0,
        1630.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1630.0130615234375,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        870.0,
        1595.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1630.0,
        87.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1615.0,
      "bbox_min": [
        870.0,
        1610.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1630.0,
        87.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -87.0,
      "bbox_min": [
        870.0,
        1610.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1615.0,
        87.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 910.0,
      "bbox_min": [
        870.0,
        1610.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1615.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        930.0,
        1610.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1615.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        970.0,
        1610.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1615.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        930.0,
        1610.0,
        77.0
      ],
      "bbox_max": [
        930.0,
        1615.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 870.0,
      "bbox_min": [
        870.0,
        1610.0,
        77.0
      ],
      "bbox_max": [
        890.0,
        1615.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1610.0,
        77.0
      ],
      "bbox_max": [
        890.0,
        1615.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1625.0,
      "bbox_min": [
        870.0,
        1625.0,
        77.0
      ],
      "bbox_max": [
        890.0,
        1630.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -87.0,
      "bbox_min": [
        870.0,
        1625.0,
        77.0
      ],
      "bbox_max": [
        890.0,
        1630.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 870.0,
      "bbox_min": [
        870.0,
        1625.0,
        77.0
      ],
      "bbox_max": [
        890.0,
        1630.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1625.0,
        77.0
      ],
      "bbox_max": [
        890.0,
        1630.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1595.0,
      "bbox_min": [
        870.0,
        1595.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1600.0,
        87.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        870.0,
        1595.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1600.0,
        87.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -87.0,
      "bbox_min": [
        870.0,
        1595.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1600.0,
        87.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 910.0,
      "bbox_min": [
        870.0,
        1595.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1600.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        930.0,
        1595.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1600.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        970.0,
        1595.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1600.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        930.0,
        1595.0,
        77.0
      ],
      "bbox_max": [
        930.0,
        1600.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 870.0,
      "bbox_min": [
        870.0,
        1595.0,
        77.0
      ],
      "bbox_max": [
        890.0,
        1600.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1595.0,
        77.0
      ],
      "bbox_max": [
        890.0,
        1600.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9405532479286194,
        0.0,
        0.3396463692188263
      ],
      "plane_d": 934.80517578125,
      "bbox_min": [
        885.0,
        1590.0,
        100.0
      ],
      "bbox_max": [
        1269.77294921875,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46532946825027466,
        0.0,
        -0.885137677192688
      ],
      "plane_d": 679.1281127929688,
      "bbox_min": [
        1036.261474609375,
        1590.0,
        101.43550872802734
      ],
      "bbox_max": [
        1269.77294921875,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1598.0,
      "bbox_min": [
        1235.0,
        1598.0,
        101.43550872802734
      ],
      "bbox_max": [
        1269.77294921875,
        1598.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1036.261474609375,
        1620.0,
        117.33944702148438
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47058823704719543,
        0.0,
        0.8823529481887817
      ],
      "plane_d": 382.3529357910156,
      "bbox_min": [
        885.0,
        1590.0,
        100.0
      ],
      "bbox_max": [
        1036.5,
        1670.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1000.0,
        1620.0,
        100.0
      ],
      "bbox_max": [
        1036.5,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        885.0,
        1590.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        118.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        885.0,
        1615.0,
        100.0
      ],
      "bbox_max": [
        940.0,
        1650.0,
        118.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9363291263580322,
        0.0,
        -0.3511234223842621
      ],
      "plane_d": -808.7542724609375,
      "bbox_min": [
        905.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9363291263580322,
        -0.0,
        -0.3511234223842621
      ],
      "plane_d": 909.40966796875,
      "bbox_min": [
        905.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.936329185962677,
        -0.3511234521865845
      ],
      "plane_d": 1578.885009765625,
      "bbox_min": [
        905.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.936329185962677,
        -0.3511234521865845
      ],
      "plane_d": -1473.548095703125,
      "bbox_min": [
        905.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8374775648117065,
        -0.41873878240585327,
        -0.3511256277561188
      ],
      "plane_d": -34.655479431152344,
      "bbox_min": [
        905.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8374775648117065,
        0.41873878240585327,
        -0.35112565755844116
      ],
      "plane_d": -1399.743896484375,
      "bbox_min": [
        905.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8374775648117065,
        0.41873878240585327,
        -0.3511256277561188
      ],
      "plane_d": 137.02737426757812,
      "bbox_min": [
        908.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8374775648117065,
        -0.41873878240585327,
        -0.35112565755844116
      ],
      "plane_d": 1502.1158447265625,
      "bbox_min": [
        908.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.584919810295105,
        -0.7311497330665588,
        -0.3511250615119934
      ],
      "plane_d": 1780.6611328125,
      "bbox_min": [
        908.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        927.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5849193930625916,
        -0.7311491966247559,
        -0.3511269986629486
      ],
      "plane_d": 707.3330078125,
      "bbox_min": [
        908.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        927.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.584919810295105,
        0.7311497330665588,
        -0.3511250615119934
      ],
      "plane_d": -1676.21484375,
      "bbox_min": [
        908.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        927.0,
        1630.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5849193930625916,
        0.7311491966247559,
        -0.3511269986629486
      ],
      "plane_d": -602.8862915039062,
      "bbox_min": [
        917.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        927.0,
        1630.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 917.0,
      "bbox_min": [
        917.0,
        1629.5,
        113.0
      ],
      "bbox_max": [
        918.0,
        1630.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1629.5,
      "bbox_min": [
        917.0,
        1629.5,
        113.0
      ],
      "bbox_max": [
        918.0,
        1630.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1630.5,
      "bbox_min": [
        917.0,
        1629.5,
        113.0
      ],
      "bbox_max": [
        918.0,
        1630.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -918.0,
      "bbox_min": [
        917.0,
        1629.5,
        113.0
      ],
      "bbox_max": [
        918.0,
        1630.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 113.0,
      "bbox_min": [
        917.0,
        1629.5,
        113.0
      ],
      "bbox_max": [
        918.0,
        1630.5,
        113.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 895.0,
      "bbox_min": [
        885.0,
        1615.0,
        100.0
      ],
      "bbox_max": [
        940.0,
        1650.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1625.0,
      "bbox_min": [
        895.0,
        1615.0,
        100.0
      ],
      "bbox_max": [
        940.0,
        1645.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        0.44721364974975586,
        0.0
      ],
      "plane_d": 105.09521484375,
      "bbox_min": [
        905.0,
        1615.0,
        100.0
      ],
      "bbox_max": [
        930.0,
        1625.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.44721364974975586,
        -0.0
      ],
      "plane_d": -1536.178955078125,
      "bbox_min": [
        905.0,
        1615.0,
        100.0
      ],
      "bbox_max": [
        927.0,
        1625.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6246950626373291,
        0.7808688282966614,
        0.0
      ],
      "plane_d": -685.1343383789062,
      "bbox_min": [
        908.0,
        1615.0,
        100.0
      ],
      "bbox_max": [
        927.0,
        1619.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1831.4498291015625,
      "bbox_min": [
        908.0,
        1615.0,
        100.0
      ],
      "bbox_max": [
        913.0,
        1619.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1635.0,
      "bbox_min": [
        895.0,
        1635.0,
        100.0
      ],
      "bbox_max": [
        940.0,
        1645.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.44721364974975586,
        0.0
      ],
      "plane_d": 1563.01171875,
      "bbox_min": [
        905.0,
        1635.0,
        100.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.44721364974975586,
        0.0
      ],
      "plane_d": -78.26239013671875,
      "bbox_min": [
        905.0,
        1635.0,
        100.0
      ],
      "bbox_max": [
        927.0,
        1645.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6246950626373291,
        -0.7808688282966614,
        0.0
      ],
      "plane_d": 1860.498046875,
      "bbox_min": [
        908.0,
        1641.0,
        100.0
      ],
      "bbox_max": [
        927.0,
        1645.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6246950626373291,
        -0.7808688282966614,
        0.0
      ],
      "plane_d": 714.1826171875,
      "bbox_min": [
        908.0,
        1641.0,
        100.0
      ],
      "bbox_max": [
        913.0,
        1645.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -885.0,
      "bbox_min": [
        885.0,
        1625.0,
        100.0
      ],
      "bbox_max": [
        895.0,
        1650.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1650.0,
      "bbox_min": [
        885.0,
        1625.0,
        100.0
      ],
      "bbox_max": [
        895.0,
        1650.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1625.0,
      "bbox_min": [
        885.0,
        1625.0,
        100.0
      ],
      "bbox_max": [
        895.0,
        1625.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        945.0,
        1590.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1845.548828125,
      "bbox_min": [
        945.0,
        1655.0,
        100.0
      ],
      "bbox_max": [
        955.0,
        1665.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        945.0,
        1590.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1605.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        945.0,
        1595.0,
        100.0
      ],
      "bbox_max": [
        955.0,
        1605.0,
        118.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: libshelf",
      "entity_class": "CSlidingDoor",
      "piece_name": "libshelf",
      "offset": 642,
      "centroid": [
        960.0,
        1627.5,
        82.0
      ],
      "bbox_min": [
        950.0,
        1625.0,
        77.0
      ],
      "bbox_max": [
        970.0,
        1630.0,
        87.0
      ],
      "dimensions_source": {
        "span_x": 20.0,
        "span_y": 5.0,
        "height_z": 10.0,
        "door_width": 20.0,
        "door_depth": 5.0,
        "leaf_depth": 4.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          950.0,
          1625.0,
          77.0
        ],
        [
          950.0,
          1630.0,
          77.0
        ],
        [
          950.0,
          1630.0,
          87.0
        ],
        [
          950.0,
          1625.0,
          87.0
        ],
        [
          970.0,
          1625.0,
          77.0
        ],
        [
          970.0,
          1625.0,
          87.0
        ],
        [
          970.0,
          1630.0,
          87.0
        ],
        [
          970.0,
          1630.0,
          77.0
        ]
      ],
      "plane_distance": 950.0
    }
  ],
  "tutorial_messages": []
}